module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top",
    style: (_vm.heightTop)
  }, [(_vm.$slots.line) ? _c('div', {
    staticClass: "top__line"
  }, [_c('div', {
    staticClass: "top__content"
  }, [_vm._t("line")], 2)]) : _vm._e(), (_vm.addMenuToggle) ? _c('div', {
    staticClass: "top__addmenu",
    style: (_vm.styleMenu)
  }, [_c('div', {
    staticClass: "top__content"
  }, [_vm._t("addMenu")], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed7b49e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/topline/Topline.vue
// module id = 5807b9b0b0dab12661f4
// module chunks = 0